import { Alert } from '@mui/material'
import { SearchOff } from '@mui/icons-material'

const NoResultsAlert = () => {
  return (
    <Alert
      severity="warning"
      icon={<SearchOff fontSize="inherit" sx={{marginTop: '0.5rem'}} />}
      sx={{
        my: 1.5,
        borderRadius: '8px',
        border: '1px solid #FDE68A',
        backgroundColor: '#FFFBEB',
        color: '#92400E',
        fontSize: '0.875rem',
        fontWeight: 600,
        fontFamily: "'Segoe UI', sans-serif",
        padding: '10px 16px',
        alignItems: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        '& .MuiAlert-icon': {
          color: '#F59E0B',
          fontSize: '1.1rem',
          marginRight: '10px',
          paddingTop: 0
        },
        '& .MuiAlert-message': {
          padding: 0,
          lineHeight: '1.5'
        }
      }}
    >
      No se encontraron resultados
    </Alert>
  )
}

export default NoResultsAlert
